<app-sales-person-dashboard-subheader/>
<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container container-fluid">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                @if (data$ | async; as data) {
                  <div class="row">
                    <div class="col col-md">
                      <div class="table-wrapper">
                        <table class="table table-striped collapsed-rounded-table">
                          <thead>
                          <tr>
                            <th translate>DASHBOARD_SALESPERSON_LBL_TYPE</th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_AMOUNT</th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_RATE</th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_COMMISSION</th>
                          </tr>
                          </thead>
                          <tbody>
                            @for (rowReport of data.commissionReportSalesPersonCommissionsDashboardAmountModels; track rowReport.id; let last = $last) {
                              <tr [class]='last ? "fw-bolder" : ""'>
                                <td>{{ rowReport.name }}</td>
                                <td class="text-end">{{ rowReport.companyAmount | showSignValueType: 'Monetary' }}</td>
                                <td
                                  class="text-end">{{ !last ? (rowReport.salesPersonCommissionRate | showSignValueType: 'Percentage') : '' }}
                                </td>
                                <td
                                  class="text-end">{{ rowReport.salesPersonCommissionAmount | showSignValueType: 'Monetary' }}
                                </td>
                              </tr>
                            }
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <button type='button' class="link-primary border-0 bg-transparent"
                                      (click)="onSmartLinkClick(this.smartAction, data.filters)"
                                      translate>DASHBOARD_SALESPERSON_LBL_LINK_COMMISSIONPREVIEW
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
